import { Patterns } from "@omni/schemas/input/patterns";
import { Translate } from "@omni/types/utils/translate";
import { addMethod, string as yupString } from "yup";

import { Config } from "@/utils/config.utils";

import { string } from "./general.RHF";

addMethod(yupString, "promotionCodeRHF", function () {
    return this.test("promotionCodeRHF", { exclusive: true }, function (value) {
        if (
            Patterns[Config.general.basestore].promotionCode.test(value || "")
        ) {
            return true;
        }
        return this.createError({
            message: () => () => (t: Translate) =>
                t("general.form.input.validation.promotionCode.invalidformat")
        });
    });
});

export const promotionCode = string()
    .min(
        2,
        ({ min }) =>
            () =>
            (t: Translate) =>
                t("general.form.input.validation.promotionCode.min", min)
    )
    .max(
        30,
        ({ max }) =>
            () =>
            (t: Translate) =>
                t("general.form.input.validation.promotionCode.max", max)
    )
    .nullable()
    .required()
    .promotionCodeRHF();
